// extracted by mini-css-extract-plugin
export default {"FeatureCard":"FeatureCard_FeatureCard__eKd4D","CardIcon":"FeatureCard_CardIcon__56oN7","CardText":"FeatureCard_CardText__JnEoH","CardTitle":"FeatureCard_CardTitle__nvY1f"};